import { OM_ORDER_MODIFICATION_SLICE_NAME } from './core';
import { orderMgmtModificationReducer } from './ordermgmt-dialog.slice';

export const OrderManagementModificationConfig = {
  name: OM_ORDER_MODIFICATION_SLICE_NAME,
  reducer: orderMgmtModificationReducer,
};
